import Freezer = require('freezer-js');
import { FreezerService } from './externals/FreezerService';
import { bind } from 'bind-decorator';
import * as _ from 'lodash';
import * as moment from 'moment-timezone';
import * as React from 'react';
import { Route } from 'react-router';
import { BrowserRouter, Link, useNavigate, NavLink, Routes, Navigate } from 'react-router-dom';
import * as managedAjaxUtil from './modules/managedAjaxUtil';
import { IAjaxState } from './modules/managedAjaxUtil';
import * as s from 'underscore.string';

export {
    React,
    BrowserRouter,
    Route,
    Link,
    NavLink,
    useNavigate,
    Routes,
    Navigate,
    bind,
    _,
    FreezerService,
    moment,
    IAjaxState,
    managedAjaxUtil,
    s,
};
